import type { ApiError } from "@/client/core/ApiError"
import { OpenAPI } from "@/client/core/OpenAPI"
import { useMutation } from "@tanstack/react-query"

// TODO: These types will be auto-generated after running ./scripts/generate-client.sh
interface GenerateRationaleRequest {
  question_id?: string | null
  question_text: string
  options: string[]
  correct_answer: number
  subject_ids?: string[] | null
  topic_ids?: string[] | null
}

interface GenerateRationaleResponse {
  rationale_html: string
  provider: string
  model: string
  estimated_cost?: number | null
}

interface GenerateRationaleParams {
  questionText: string
  options: string[]
  correctAnswer: number
  questionId?: string
  subjectIds?: string[]
  topicIds?: string[]
}

export function useGenerateRationale() {
  return useMutation<
    GenerateRationaleResponse,
    ApiError,
    GenerateRationaleParams
  >({
    mutationFn: async (params) => {
      const apiBaseUrl = (
        OpenAPI.BASE ||
        import.meta.env.VITE_API_URL ||
        ""
      ).replace(/\/$/, "")

      if (!apiBaseUrl) {
        throw new Error(
          "API base URL is not configured. Set VITE_API_URL to your backend origin.",
        )
      }

      const request: GenerateRationaleRequest = {
        question_text: params.questionText,
        options: params.options,
        correct_answer: params.correctAnswer,
        question_id: params.questionId || null,
        subject_ids: params.subjectIds || null,
        topic_ids: params.topicIds || null,
      }

      // Manual API call until client is regenerated
      const response = await fetch(
        `${apiBaseUrl}/api/v1/ai/generate-rationale`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify(request),
        },
      )

      if (!response.ok) {
        const error = await response.json()
        throw new Error(error.detail || "Failed to generate rationale")
      }

      return response.json()
    },
  })
}
